import {useQuery} from "@tanstack/react-query";
import {getMenuList} from "../../../store/Menu/api";

export const useGetMenuList = (filters) => {
    const queryParams = Object.assign({}, filters)
    if(queryParams.status !== "archived") {
        delete queryParams.status
    }
    return useQuery(
        ["menu-list", filters.status],
        () => getMenuList(queryParams)
    );
}
